import React from "react";

export const AngleRight = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.0003 17.0003C9.74428 17.0003 9.48825 16.9023 9.29325 16.7073C8.90225 16.3163 8.90225 15.6842 9.29325 15.2933L12.5862 12.0003L9.29325 8.70731C8.90225 8.31631 8.90225 7.68425 9.29325 7.29325C9.68425 6.90225 10.3163 6.90225 10.7073 7.29325L14.7073 11.2933C15.0983 11.6842 15.0983 12.3163 14.7073 12.7073L10.7073 16.7073C10.5123 16.9023 10.2563 17.0003 10.0003 17.0003Z"
      fill="black"
    />
  </svg>
);
